/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateJobNotificationSettingsCommandDto interface.
 */
export function instanceOfUpdateJobNotificationSettingsCommandDto(value) {
    if (!('jobId' in value) || value['jobId'] === undefined)
        return false;
    if (!('subscribedEmployerIds' in value) || value['subscribedEmployerIds'] === undefined)
        return false;
    return true;
}
export function UpdateJobNotificationSettingsCommandDtoFromJSON(json) {
    return UpdateJobNotificationSettingsCommandDtoFromJSONTyped(json, false);
}
export function UpdateJobNotificationSettingsCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'jobId': json['jobId'],
        'subscribedEmployerIds': json['subscribedEmployerIds'],
    };
}
export function UpdateJobNotificationSettingsCommandDtoToJSON(json) {
    return UpdateJobNotificationSettingsCommandDtoToJSONTyped(json, false);
}
export function UpdateJobNotificationSettingsCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'jobId': value['jobId'],
        'subscribedEmployerIds': value['subscribedEmployerIds'],
    };
}
